import React from "react"

import { Floor } from "shared/types/Floor"
import { DragSource } from "shared/types/drag-and-drop/DragSource"
import { DropTarget } from "shared/types/drag-and-drop/DropTarget"

import { FloorTabRendererProps } from "./ProjectPageFloorTabConnector"
import { ProjectPageTabBarView } from "./ProjectPageTabBarView"
import { useProjectPageTabBarViewModel } from "./model/useProjectPageTabBarViewModel"

export interface ProjectPageTabBarProps {
  projectID: string
  floors: Floor[]
  onSelect: (floorID: string | null) => void
  activeTabID: string | null
  unassignedRoomsCount: number
  unassignedProductsCount: number
  onSelectFloor: (floorID: string, event?: React.MouseEvent) => void
  truncationThreshold?: number
  onFloorSort?: (floorID: string, oldIndex: number, newIndex: number) => void
  ariaControls?: string
  onDrop?: (dragSource: DragSource, dropTarget: DropTarget) => void
  FloorTabRenderer?: React.ComponentType<FloorTabRendererProps>
}

export const ProjectPageTabBar = React.memo((props: ProjectPageTabBarProps) => {
  return <ProjectPageTabBarView {...useProjectPageTabBarViewModel(props)} />
})
